var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatedTicketIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9331 5.42674L17.8131 4.54675C18.5422 3.81775 19.7242 3.81775 20.4531 4.54675C21.1821 5.27577 21.1821 6.45771 20.4531 7.18673L19.5731 8.06672M16.9331 5.42674L11.0137 11.3461C10.5626 11.7973 10.2426 12.3625 10.0879 12.9814L9.44434 15.5556L12.0185 14.912C12.6374 14.7573 13.2026 14.4372 13.6538 13.9861L19.5731 8.06672M16.9331 5.42674L19.5731 8.06672",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2221 13.3329C19.2221 16.2551 19.2221 17.7162 18.4151 18.6997C18.2674 18.8797 18.1023 19.0447 17.9222 19.1925C16.9388 19.9996 15.4777 19.9996 12.5555 19.9996H12.1111C8.7589 19.9996 7.08281 19.9996 6.04141 18.9581C5.00003 17.9168 5 16.2406 5 12.8885V12.444C5 9.52181 5 8.06071 5.80706 7.07729C5.95482 6.89725 6.11991 6.73216 6.29995 6.5844C7.28337 5.77734 8.74446 5.77734 11.6667 5.77734",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedTicketIc);
export default __webpack_public_path__ + "static/media/created_ticket_ic.784d68828ad6c7361e7a7c78e6ddf70a.svg";
export { ForwardRef as ReactComponent };